function Icon({iconName, size, color}) {
    return (
      <div className="icon hoverPointer">
        <ion-icon name={iconName} style={{width: size, height: size, marginTop: "1vh", color: color}}></ion-icon>
      </div>
    );
  }
  
  export default Icon;